import { SET_CHANGE } from 'src/actions/types'

const initialState = {
  sidebarShow: true,
  sidebarUnfoldAble: false,
}
export default function (state = initialState, action) {
  const { type, ...rest } = action
  switch (type) {
    // case 'set':
    case SET_CHANGE:
      return { ...state, ...rest }
    default:
      return state
  }
}
